import React from "react";
import Typography from "@material-ui/core/Typography";
import * as APIStore from "../../store/APIStore";

export interface PatientRoomDisplayProps {
    encounter: APIStore.Encounter,
}

const PatientRoomDisplay = (props: PatientRoomDisplayProps) => {
    let { roomNumber } = props.encounter;
    if (!roomNumber) {
        return <></>
    }

    return (
        <>
            <Typography variant="body1" component="div" gutterBottom>
                <strong>Room Number:{" "}</strong>
                <Typography variant="body2" component="span" gutterBottom="100">
                    {roomNumber}
                </Typography>
            </Typography>
        </>
    )
}

export default PatientRoomDisplay